var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","aria-hidden":"true","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M1.5 12.002h20.918"}}),_vm._v(" "),_c('path',{attrs:{"stroke-linejoin":"round","d":"m1.361 12.001 5.095 5.094Zm5.095-5.095-5.095 5.095Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }